import { customersApiService } from './customersApiService';

export const searchService = {
  fetchSearchResults: async (customerName, customerNumber, ticketNumber) => {
    try {
      // Get all tickets from external Customers API
      const allTickets = await customersApiService.getAllTickets();

      // Filter tickets based on search criteria
      const filteredTickets = allTickets.filter(ticket => {
        let matches = true;

        if (customerName) {
          matches = matches && ticket.customer_name &&
                   ticket.customer_name.toLowerCase().includes(customerName.toLowerCase());
        }

        if (customerNumber) {
          matches = matches && ticket.customer_number &&
                   ticket.customer_number.toLowerCase().includes(customerNumber.toLowerCase());
        }

        if (ticketNumber) {
          matches = matches && ticket.ticket_number &&
                   ticket.ticket_number.toLowerCase().includes(ticketNumber.toLowerCase());
        }

        return matches;
      });

      return filteredTickets;
    } catch (error) {
      console.error('Error searching tickets:', error);
      return [];
    }
  }
};